import React from "react";
import { BrowserRouter, Route } from "react-router-dom";

import checkout from "./pages/checkout";
import modernCheckout from "./pages/modern_checkout"; // Checkout moderno
import modernDetalhe from "./pages/modern_detalhe"; // Detalhes moderno
import detalhe from "./pages/detalhe";
import estoqueSeguranca from './pages/estoque_seguranca'
import modernHome from "./pages/modern_home"; // Nova home moderna - AGORA É A PRINCIPAL
import modernFavoritos from "./pages/modern_favoritos"; // Página moderna de favoritos
import modernLogin from "./pages/modern_login"; // Login moderno
import modernPedidosCliente from "./pages/modern_pedidos_cliente"; // Pedidos cliente moderno
import modernPedidosLoja from "./pages/modern_pedidos_loja"; // Pedidos loja moderno
import modernTrocarSenha from "./pages/modern_trocar_senha"; // Trocar senha moderno
import home from "./pages/home"; // Home original (backup)
import testeApi from "./pages/teste_api"; // Página de teste da API
import interesses from "./pages/interesses";
import login from "./pages/login";
import PedidosCliente from "./pages/pedidos_cliente";
import pedidos from "./pages/pedidos";
import pedidosLoja from "./pages/pedidos_loja";
import trocarSenha from "./pages/trocar_senha";

function Routes() {
  return (
    <BrowserRouter>
      <Route path="/checkout" exact component={modernCheckout} />
      <Route path="/checkout-original" exact component={checkout} />
      <Route path="/detalhe" exact component={modernDetalhe} />
      <Route path="/detalhe-original" exact component={detalhe} />
      <Route path="/estoque_seguranca" component={estoqueSeguranca} />
      <Route path="/" exact component={modernHome} />
      <Route path="/home" exact component={modernHome} />
      <Route path="/moderno" exact component={modernHome} />
      <Route path="/teste-api" exact component={testeApi} />
      <Route path="/home-original" exact component={home} />
      <Route path="/interesses" component={interesses} />
      <Route path="/favoritos" exact component={modernFavoritos} />
      <Route path="/login" component={modernLogin} />
      <Route path="/login-original" component={login} />
      <Route path="/pedidos_cliente" component={modernPedidosCliente} />
      <Route path="/pedidos_cliente_original" component={PedidosCliente} />
      <Route path="/pedidos_loja" exact component={modernPedidosLoja} />
      <Route path="/pedidos_loja_original" exact component={pedidosLoja} />
      <Route path="/pedidos" exact component={pedidos} />
      <Route path="/trocar_senha" component={modernTrocarSenha} />
      <Route path="/trocar_senha_original" component={trocarSenha} />
    </BrowserRouter>
  );
}

export default Routes;